export default __webpack_public_path__ + "static/media/semipermanentbarrier.46b6d574.png";